type HarvestOption = {
  label: string;
  value: string;
};

export function getProjectHarvestOptions(currentYear: number): HarvestOption[] {
  return Array.from({ length: 4 }, (_, index) => {
    const startYear = currentYear - 1 + index;
    const endYear = startYear + 1;

    return {
      value: `${startYear}-${endYear}`,
      label: `Safra ${startYear}/${endYear}`,
    };
  });
}
